import { NgIf, NgStyle } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface AlertDialogData {
    title?: string;
    message: string;
    submessage?: string;
    okText?: string;
    cancelText?: string;
    icon?: string;
    isDeleteLoading?: boolean;
    dialogBgColor?: string;
    okButtonColor?: string;
    cancelButtonColor?: string;
    okButtonTextColor?: string;
    cancelButtonTextColor?: string;
}

@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    imports: [NgIf, NgStyle, MatDialogModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AlertDialogComponent {
    @Output() onLoadingChange = new EventEmitter<boolean>();
    
    constructor(
        public dialogRef: MatDialogRef<AlertDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AlertDialogData
    ) { }
    
    onOkClick(): void {
        if (!this.data.isDeleteLoading) {
            this.onLoadingChange.emit(true);
            this.dialogRef.close(true);
        }
    }
    
    onCancelClick(): void {
        if (!this.data.isDeleteLoading) {
            if(this.data.cancelText =="Reject"){
                this.onLoadingChange.emit(true);
                this.dialogRef.close({
                    action:'Reject',
                    status: false
                });
            }else{
                this.dialogRef.close(false);
            }
        }
    }
    
    getDialogContainerStyle(): any {
        return {
            'background-color': this.data.dialogBgColor || 'var(--secondary-color)'
        };
    }
    
    getOkButtonStyle(): any {
        return {
            'background-color': this.data.okButtonColor || 'var(--red-color)',
            'color': this.data.okButtonTextColor || 'var(--text-primary-color)'
        };
    }
    
    getCancelButtonStyle(): any {
        return {
            'background-color': this.data.cancelButtonColor || 'var(--blue-color)',
            'color': this.data.cancelButtonTextColor || 'var(--text-primary-color)'
        };
    }
}